var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgQueries16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2597 14.2438L13.3753 14.3456L13.4848 14.2372L14.6161 13.1173L14.7417 12.9929L14.609 12.8761L11.9138 10.5046C12.4585 9.70788 12.7733 8.74486 12.7644 7.70945C12.7409 4.99268 10.4976 2.81198 7.75734 2.83518C5.01703 2.85838 2.81171 5.07678 2.83519 7.79357C2.85866 10.5103 5.10194 12.691 7.84223 12.6678C8.83992 12.6594 9.76669 12.36 10.5408 11.8514L13.2597 14.2438ZM10.8345 7.72585C10.8488 9.38254 9.50336 10.7399 7.82575 10.7541C6.14812 10.7683 4.77935 9.43389 4.76504 7.77718C4.75073 6.12049 6.09621 4.76315 7.77382 4.74895C9.45145 4.73475 10.8202 6.06913 10.8345 7.72585Z",
    fill: "#18191B",
    stroke: "#18191B",
    strokeWidth: 0.33
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQueries16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;